import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';


class ExecutionReportDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            isDataAvailable: false
        }
    }
    // handleClickGetKpiStatus = (key,cad_name) => {
    //     localStorage.setItem("cad_uuid", key);
    //     window.open("/AutomateKPI/4/", cad_name);
    //     console.log("cad details:", key, cad_name)
    //   };

    render() {
        console.log(this.props)
        return (
            <div data-test = 'closedLoopPerformanceReportExecutionReportDetailsComponent'>
                { Object.keys(this.props.executionInfo).length > 0 ?
                 <div className='row'>
                    <div className='col-12'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table'>
                                    <thead>
                                        <tr className="table-head" valign="middle" align="middle">
                                            <th scope="col" key="executionDate" style={{ textAlign: "center" }}>Date</th>
                                            <th scope="col" key="executionTime" style={{ textAlign: "center" }}>Time(GMT)</th>
                                            <th scope="col" key="adVersion" style={{ textAlign: "center" }}>AD Version</th>
                                            <th scope="col" key="cadTopologyId" style={{ textAlign: "center" }}>CAD Topology Id</th>
                                            <th scope="col" key="cadName" style={{ textAlign: "center" }}>CAD Name</th>
                                            <th scope="col" key="baseScenarioCount" style={{ textAlign: "center" }}>Base Scenario Count</th>
                                            <th scope="col" key="kpiStatus" style={{ textAlign: "center" }}>KPI Status</th>
                                            <th scope="col" key="ticketId/userId" style={{ textAlign: "center" }}>Initiated By</th>
                                            <th scope="col" key="region" style={{ textAlign: "center" }}>Region</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.executionInfo.map((val, key) => {
                                        console.log(key)
                                        const id = []
                                        if( val['ticket_id'] === "None"){
                                            id[0] = val["user_id"]
                                        }
                                        else{
                                            id[0] = val["ticket_id"]
                                        }
                                        return (
                                            <tr key={key} valign="middle" className="table-row" style={{ verticalAlign: "text-top" }}>
                                            <td>{ val['execution_date'] }</td>
                                            <td>{ val['execution_start_time'] }</td>
                                            <td>{ val['ad_version'] }</td>
                                            <td key={`CAD Topology Id_${key}`}>
                                                {/* {" "}
                                                <a
                                                onClick={() => {
                                                    this.handleClickGetKpiStatus(val['cad_topology_id'],val['cad_name']);
                                                }}
                                                >
                                                {" "}
                                                {val['cad_topology_id']}state={{ from: "occupation" }}
                                                </a> */}
                                                <Link to={{ pathname:"/AutomateKPI/4", data:{cad_id:val['cad_topology_id'], cad_name: val['cad_name']}}} className="nav-link" style={{ textDecoration: "none", color: "#464646", fontWeight: "bold" }}>
                                                    {val['cad_topology_id']}
                                                </Link>
                                            </td>
                                            <td>{ val['cad_name'] }</td>
                                            <td>{ val['base_scenario_count'] }</td>
                                            <td>{ val['kpi_status'] }</td>
                                            <td>{id[0] }</td>
                                            <td>{ val['region'] }</td>
                                            
                                            </tr>
                                        )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                 </div>
                 :<div className='row'>
                    <div className='col-12'>
                        <div className="alert alert-danger" role="alert">
                            No Data Available
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
}
ExecutionReportDetails.propTypes={
executionInfo:PropTypes.string,
}
ExecutionReportDetails.defaultProps= {
executionInfo:[],
}
export default ExecutionReportDetails;
